module.exports = __webpack_public_path__ + "static/media/funnel_data_sample_mobile.7cae8cc3.png";